import { Routes } from '@angular/router';


export const content: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('../../modules/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'kardex',
    loadChildren: () => import('../../modules/kardex/kardex.module').then(m => m.KardexModule)
  },
  {
    path: 'personal',
    loadChildren: () => import('../../modules/personal/personal.module').then(m => m.PersonalModule)
  },
  {
    path: 'detalle',
    loadChildren: () => import('../../modules/complemento/complemento.module').then(m => m.ComplementoModule)
  },
  {
    path: 'almacen',
    loadChildren: () => import('../../modules/almacen/almacen.module').then(m => m.AlmacenModule)
  },
  {
    path: 'planilla',
    loadChildren: () => import('../../modules/planillas/planillas.module').then(m => m.PlanillasModule)
  }
];
